module.exports = __webpack_public_path__ + "img/zhunzhong.144bc74f.jpg";